module.exports = __webpack_public_path__ + "static/media/wall-large-3.f3b84cfd.jpg";